import styled, { css } from 'styled-components';
import { breakpointDown, breakpointUp } from './Breakpoints';

interface Props {
  $noVerticalTopPadding?: boolean;
  $noVerticalBottomPadding?: boolean;
  $header?: boolean;
  $footer?: boolean;
  $narrow?: boolean;
  $narrowish?: boolean;
  $business?: boolean;
  $mainContent?: boolean;
  $debug?: boolean;
}

function headerStyle({ $header = false }: Props) {
  if ($header) {
    return css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 12%;
      ${breakpointDown('tablet')} {
        padding: 1rem 1.5rem;
      }
    `;
  }
}

function footerStyle({ $footer = false, $debug = false }: Props) {
  if ($footer) {
    return css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${
        !$debug &&
        css`
        padding-top: 0;
        padding-bottom: 0;
      `
      }
      ${breakpointUp('tablet')} {
        padding: 1rem 3.846%;
      }
      ${breakpointDown('tablet')} {
        padding: 1rem 6.25%;
      }

      > * {
        display: flex;
        align-items: center;
        margin: 0 -1rem;
        ${breakpointDown('tablet')} {
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
        }

        > * {
          padding: 0 1rem;
        }
      }
    `;
  }
}

function narrowStyle({ $narrow }: Props) {
  if ($narrow) {
    return css`
      padding: 0 !important;
      ${breakpointDown('desktop')} {
        max-width: 30rem;
      }
      ${breakpointUp('desktop')} {
        max-width: 66%;
        max-width: 30rem;
      }
    `;
  }
}

function narrowishStyle({ $narrowish }: Props) {
  if ($narrowish) {
    return css`
      padding: 0 !important;
      ${breakpointDown('desktop')} {
        max-width: 60rem;
      }
      ${breakpointUp('desktop')} {
        max-width: 80rem;
      }
    `;
  }
}

function businessStyle({ $business, $mainContent }: Props) {
  if ($business) {
    if ($mainContent) {
      return css`
        padding-top: 1rem;
      `;
    }
    return css`
      padding: 0 !important;
      max-width: 62.666666rem;
    `;
  }
}

function noVerticalTopPaddingStyle({ $noVerticalTopPadding = false }: Props) {
  if ($noVerticalTopPadding) {
    return css`
      padding-top: 0;
    `;
  }
}

function noVerticalBottomPaddingStyle({ $noVerticalBottomPadding = false }: Props) {
  if ($noVerticalBottomPadding) {
    return css`
      padding-bottom: 0;
    `;
  }
}

function mainContentStyle({ $mainContent = false }: Props) {
  if ($mainContent) {
    return css`
      flex: 1 0 auto;
      min-height: 50vh;
      ${breakpointDown('tablet')} {
        padding: 2rem 1.5rem 1.5rem 1.5rem;
      }
    `;
  }
}

export default styled.div<Props>`
  position: relative;
  width: 100%;
  padding: 2.5rem 3rem 2rem 3rem;
  ${noVerticalTopPaddingStyle}
  ${noVerticalBottomPaddingStyle}
  ${headerStyle}
  ${footerStyle}
  ${narrowStyle}
  ${narrowishStyle}
  ${businessStyle}
  ${mainContentStyle}
`;
